var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28405_17296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.47301 0.5 0 4.9725 0 10.5C0 16.0269 4.4725 20.5 10 20.5C15.527 20.5 20 16.0275 20 10.5C20 4.97309 15.5275 0.5 10 0.5ZM10 19.1046C5.25539 19.1046 1.39535 15.2446 1.39535 10.5C1.39535 5.75535 5.25539 1.89535 10 1.89535C14.7446 1.89535 18.6046 5.75535 18.6046 10.5C18.6046 15.2446 14.7446 19.1046 10 19.1046Z",
    fill: "#099EF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 8.83594C9.40754 8.83594 8.98633 9.08609 8.98633 9.45465V14.4697C8.98633 14.7857 9.40754 15.1015 9.99988 15.1015C10.5659 15.1015 11.0266 14.7857 11.0266 14.4697V9.45457C11.0266 9.08605 10.5659 8.83594 9.99988 8.83594Z",
    fill: "#099EF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 5.74219C9.3957 5.74219 8.92188 6.17656 8.92188 6.67676C8.92188 7.17699 9.39574 7.62453 10.0012 7.62453C10.5936 7.62453 11.0675 7.17699 11.0675 6.67676C11.0675 6.17656 10.5935 5.74219 10.0012 5.74219Z",
    fill: "#099EF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28405_17296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.732412203ae22673f99fb61919104b6b.svg";
export { ForwardRef as ReactComponent };